'use client'
import styles from './styled.module.scss'
import { useAppSetting, useUpdateAppSetting } from '@/components/appStore'

const Theme = () => {
  const theme = useAppSetting('theme')
  const forceTheme = useAppSetting('forceTheme')
  const updateAppSetting = useUpdateAppSetting()
  return (
    <div className={styles.container}>
      {/*强制深色模式不允许切换，找产品确认过*/}
      {forceTheme && forceTheme === 'dark' ? (
        <i className="iconfont iconrijianmoshi f20 cursor-not-allowed"></i>
      ) : theme === 'light' ? (
        <i className="iconfont iconmoshi-24 f20" onClick={() => updateAppSetting('theme', 'dark')}></i>
      ) : (
        // <Moon size={20} onClick={() => updateAppSetting('theme','dark')} />
        <i className="iconfont iconrijianmoshi f20" onClick={() => updateAppSetting('theme', 'light')}></i>
        // <Sun size={20} onClick={() => updateAppSetting('theme','light')} />
      )}
    </div>
  )
}

export default Theme
